import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from '@us/web/shared/data-access';
import { Shop } from '@us/web/shared/data-access';
import { identity, pickBy } from 'lodash';
import { convertShopOption } from '@us/web/shared/utils';

@Injectable({
    providedIn: 'root'
})
export class ShopService {
    constructor(private apiService: ApiService) {}

    public getShopInfo(params: { shop_id?: string; lat?: number; lng?: number }): Observable<Shop> {
        return this.apiService.get('shop/info', { params: pickBy(params, identity) }).pipe(
            map(shop => ({
                ...shop,
                options: convertShopOption(shop.options)
            }))
        );
    }

    public getShopIdByTableId(params: { table_id: number }) {
        return this.apiService.get<{ shop_id: string }>('shop/get-shop-id-by-table-id', { params });
    }

    public getListShops(params: { shop_id?: string; lat?: number; lng?: number }): Observable<Shop[]> {
        return this.apiService.get<Shop[]>(`shop/chain`, { params: pickBy(params, identity) }).pipe(
            map(shops =>
                shops.map(shop => ({
                    ...shop,
                    options: convertShopOption(shop.options)
                }))
            )
        );
    }
}
